(function ($) {
  $(document).ready(function () {
    // Get all table elements inside #content
    var tables = $("#content table");

    tables.each(function () {
      var table = $(this);
      // Does it have a nearest .table-container?
      var container = table.closest(".table-container");
      if (container.length === 0) {
        // If not, wrap it in a new .table-container
        table.wrap('<div class="table-container"></div>');
      }
    });
  });
})(jQuery);
